"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remToPx = remToPx;
exports.pxToRem = pxToRem;
exports.colourMap = colourMap;
exports.getTheme = getTheme;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createMuiTheme = _interopRequireDefault(require("@material-ui/core/styles/createMuiTheme"));

var _blue = _interopRequireDefault(require("@material-ui/core/colors/blue"));

var _cyan = _interopRequireDefault(require("@material-ui/core/colors/cyan"));

var _orange = _interopRequireDefault(require("@material-ui/core/colors/orange"));

var _red = _interopRequireDefault(require("@material-ui/core/colors/red"));

var _teal = _interopRequireDefault(require("@material-ui/core/colors/teal"));

require("typeface-montserrat");

require("typeface-open-sans");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function remToPx(rem) {
  return parseFloat(window.getComputedStyle(document.body).getPropertyValue('font-size')) * parseFloat(rem);
}

function pxToRem(px) {
  return px / parseFloat(parseInt(window.getComputedStyle(document.body).getPropertyValue('font-size')).toPrecision(4));
}

function colourMap(id, index, matches, colours) {
  console.log("COLOUR IND", index);

  if (matches) {
    if (Object.keys(matches).includes(id)) {
      return matches[id];
    } else {
      var matchColours = Object.values(matches);
      var availableColours = colours.filter(function (element) {
        return !matchColours.includes(element);
      });
      console.log('AVAIL COLOURS', availableColours);
      return availableColours[index];
    }
  } else {
    return colours[index];
  }
}

function getPalette(mode) {
  var palette = mode === 'light' ? {
    type: 'light',
    primary: _blue["default"],
    secondary: {
      light: '#837c7e',
      main: '#565052',
      dark: '#2d282a',
      contrastText: '#fafafa'
    },
    error: _red["default"],
    text: {
      primary: 'rgba(45, 45, 45, 0.87)',
      secondary: 'rgba(250, 250, 250, 0.87)',
      disabled: 'rgba(45, 45, 45, 0.38)',
      hint: 'rgba(45, 45, 45, 0.66)',
      icon: 'rgba(45, 45, 45, 0.66)',
      divider: _blue["default"][300],
      lightDivider: 'rgba(0, 0, 0, 0.075)'
    },
    action: {
      active: 'rgba(0, 0, 0, 0.54)',
      disabled: 'rgba(0, 0, 0, 0.26)',
      unsaved: '#E7E732',
      saved: {
        main: _teal["default"][500],
        contrastText: 'white'
      }
    },
    background: {
      "default": '#fafafa',
      paper: '#fff',
      appBar: '#f5f5f5',
      contentFrame: '#eeeeee'
    }
  } : {
    type: 'dark',
    primary: _cyan["default"],
    secondary: {
      light: '#837c7e',
      main: '#565052',
      dark: '#2d282a',
      contrastText: '#fafafa'
    },
    error: _red["default"],
    text: {
      primary: 'rgba(250, 250, 250, 0.87)',
      secondary: 'rgba(250, 250, 250, 0.87)',
      disabled: 'rgba(45, 45, 45, 0.38)',
      hint: 'rgba(45, 45, 45, 0.66)',
      icon: 'rgba(45, 45, 45, 0.66)',
      divider: _blue["default"][300],
      lightDivider: 'rgba(0, 0, 0, 0.075)'
    },
    action: {
      active: 'rgba(0, 0, 0, 0.54)',
      disabled: 'rgba(0, 0, 0, 0.26)',
      unsaved: '#E7E732',
      saved: {
        main: _teal["default"][500],
        contrastText: 'white'
      }
    },
    background: {
      "default": '#1f1f1f',
      paper: '#2d2d2d',
      appBar: '#2d2d2d',
      contentFrame: '#575757'
    }
  };
  return palette;
}

function getTheme() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  var palette = getPalette(mode);
  var theme = (0, _createMuiTheme["default"])({
    name: 'MyGlobeTheme',
    direction: 'ltr',
    spacing: 16,
    palette: palette,
    typography: {
      htmlFontSize: 16,
      fontSize: 14,
      fontFamily: '"Open Sans", sans-serif',
      h1: {
        fontSize: '3rem',
        fontFamily: '"Montserrat", sans-serif',
        fontWeight: 'bold',
        fontStyle: 'normal',
        textTransform: 'uppercase'
      },
      h2: {
        fontSize: '2rem',
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: 'bold',
        fontStyle: 'normal'
      },
      h3: {
        fontSize: '1.5rem',
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: 'bold',
        fontStyle: 'normal'
      },
      h4: {
        fontSize: '1.5rem',
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: 'normal',
        fontStyle: 'normal'
      },
      h5: {
        fontSize: '1.25rem',
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: 'normal',
        fontStyle: 'normal'
      },
      h6: {
        fontSize: '1.1rem',
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: 'normal',
        fontStyle: 'normal'
      },
      body1: {
        fontSize: '1rem',
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: 'normal',
        fontStyle: 'normal'
      },
      button: {
        fontSize: '1rem',
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: 'bold',
        fontStyle: 'normal',
        textTransform: 'uppercase',
        letterSpacing: '0.08rem'
      },
      caption: {
        fontSize: '1rem',
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: 'bold',
        fontStyle: 'normal',
        textTransform: 'uppercase',
        letterSpacing: '0.08rem'
      }
    }
  });
  theme.overrides = {
    MuiFormControl: {
      root: {
        height: '100%'
      }
    },
    MuiInput: {
      root: {
        height: '100%'
      }
    },
    MuiInputBase: {
      input: {
        height: '2.5em',
        padding: 0
      }
    },
    MuiTab: {
      root: {
        fontSize: '1rem',
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: 'bold',
        fontStyle: 'normal',
        textTransform: 'uppercase',
        letterSpacing: '0.08rem'
      }
    },
    MuiListItem: {
      gutters: {
        paddingLeft: 0,
        paddingRight: 0
      }
    },
    MuiListItemText: {
      root: {
        marginTop: '0.25rem',
        marginBottom: '0.25rem'
      }
    },
    MuiListItemIcon: {
      root: {
        minWidth: '2rem'
      }
    }
  };
  return theme;
}

getTheme.propTypes = {
  mode: _propTypes["default"].oneOf(['light', 'dark'])
};
getTheme.defaultProps = {
  mode: 'light'
};
var defaultTheme = getTheme();
var _default = defaultTheme;
exports["default"] = _default;